import {
    faArrowDownToSquare,
    faArrowsRotate,
    faCheckCircle,
    faInfoCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "@tanstack/react-query";
import { useDatadownloadsApiClient } from "../../hooks";
import { PrimaryButton, SecondaryButton } from "../../ui/Buttons";

interface DataExportStatusProps {
    exportId: string;
    onClose: () => void;
}

export const DataExportStatus = (props: DataExportStatusProps) => {
    const apiClient = useDatadownloadsApiClient();
    const exportStatusQuery = useQuery({
        queryKey: ["exportStatus", props.exportId],
        queryFn: async () => {
            const response = await apiClient.datadownloadsDataPackageRetrieve({
                id: props.exportId,
            });
            return response;
        },
        refetchInterval: (data) => {
            return !data || data?.dataDownloadStatus !== "READY" ? 4000 : false;
        },
    });

    const downloadArchive = async (dataPackageId: string) => {
        const response =
            await apiClient.datadownloadsDataPackageDownloadUrlRetrieve({
                id: dataPackageId,
            });
        window.open(response.downloadUrl);
    };

    if (
        exportStatusQuery.data &&
        exportStatusQuery.data.dataDownloadStatus === "READY"
    ) {
        return (
            <div className="w-full h-full flex flex-col items-center mt-16 gap-6">
                <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="h-20 text-ae-blue-550"
                />
                <p className="font-bold text-2xl">Your data export is ready!</p>
                <p className="max-w-96 text-center">
                    Click the button below to download your file.
                </p>
                <PrimaryButton onClick={() => downloadArchive(props.exportId)}>
                    <FontAwesomeIcon icon={faArrowDownToSquare} />
                    Download
                </PrimaryButton>
            </div>
        );
    }

    return (
        <div className="w-full h-full flex flex-col items-center mt-16 gap-6">
            <FontAwesomeIcon
                icon={faInfoCircle}
                className="h-20 text-ae-blue-550"
            />
            <p className="font-bold text-2xl">
                Your export is being processed!
            </p>
            <p className="max-w-96 text-center">
                Your file is being processed and may take some time to prepare.
                If you navigate away we'll notify you via email when the file is
                ready.
            </p>
            <div>
                <FontAwesomeIcon
                    icon={faArrowsRotate}
                    className="animate-spin h-8"
                />
            </div>
            <p>Thank you for your patience!</p>

            <SecondaryButton onClick={props.onClose}>Close</SecondaryButton>
        </div>
    );
};
